

import React, { useContext, useEffect, useMemo } from 'react'
import { useTable } from 'react-table'
import { useQueryResponseData, useQueryResponseLoading } from './response'
import { UsersListLoading } from './loading'
import { KTCardBody } from '../../_metronic/helpers'
import clsx from 'clsx'
import { UsersListPagination } from './Pagination'
import { useIsWeb } from './helper'
import { useListView } from './view'
import KycPagination from './kycPagination'
import { ComponentRequest } from './componentLayout'
/**
 * Tables Component
 *
 * Renders a responsive, styled table using react-table, with pagination, loading, and custom header/cell logic.
 *
 * Features:
 * - Displays data in a table with dynamic columns
 * - Handles loading state and empty data
 * - Integrates with global list view and query response hooks
 * - Supports pagination and custom row/cell rendering
 *
 * Props:
 * - columns: Array of column definitions for react-table
 * - pagination: Number to enable/disable pagination (default: 1)
 */
const Tables = ({ columns, pagination = 1 }) => {
    const { onSelectAll, } = useListView();
    const users = useQueryResponseData()
    const isLoading = useQueryResponseLoading()
    const isWeb = useIsWeb(768);
    const data = useMemo(() => users, [users])
    const { comRequest } = useContext(ComponentRequest)

    useEffect(() => {
        if (Number(pagination) === 0) {
            onSelectAll()

        }
    }, [data, pagination])

    const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({ columns, data })


    return (
        <KTCardBody className={isWeb ? 'py-4' : 'py-4 p-0'}>
            {isLoading && <UsersListLoading />}
            <div className='table-responsive rounded'>
                <table
                    id='kt_table_tm_tree'
                    className='table align-middle table-striped fs-6 gy-5 gx-4 dataTable no-footer'
                    {...getTableProps()}
                >
                    <thead className='bg-dark p-2'>
                        <tr className="text-left text-muted fw-bold fs-7 text-uppercase gs-0">
                            {headers.map((column, i) => {
                                const { key, ...rest } = column.getHeaderProps() // extract key separately

                                return column.Header && typeof column.Header === "string" ? (
                                    <th key={key} {...rest}>
                                        {column.render("Header")}
                                    </th>
                                ) : (
                                    <React.Fragment key={key}>{column.render("Header")}</React.Fragment>
                                )
                            })}
                        </tr>

                    </thead>
                    <tbody className='text-gray-600 fw-semibold text-capitalize' {...getTableBodyProps()}>
                        {rows.length > 0 ? (
                            rows.map((row, i) => {
                                prepareRow(row)
                                const { key, ...rowProps } = row.getRowProps()
                                return (
                                    <tr key={`row-${i}-${row.id}`} className='text-left' {...rowProps}>
                                        {row.cells.map((cell, i) => {
                                            const { key: cellKey, ...cellProps } = cell.getCellProps()
                                            return (
                                                <td
                                                    key={`cell-${i}-${cell.column.id}`}
                                                    {...cellProps}
                                                    className={clsx({ 'text-left min-w-100px': cell.column.id === 'actions' })}
                                                >
                                                    {cell.render('Cell')}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan={headers?.length}>
                                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                        No matching records found
                                    </div>
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
            </div>
            {comRequest?.type === "kyc" ? (
                <KycPagination />
            ) : (
                Number(pagination) === 1 && <UsersListPagination />
            )}
        </KTCardBody>
    )
}

export { Tables }
